<template>
	<div>
		<v-dialog
			v-model="dialog"
			max-width="600px"
			:fullscreen="$vuetify.breakpoint.xs ? true : false"
			:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		>
			<template v-slot:activator="{ on, attrs }">
				<v-btn
					:text="text"
					:color="text ? 'white' : 'secondary'"
					class="ml-2"
					@click.stop="dialog = true"
					v-bind="attrs"
					v-on="on"
				>
					<v-icon class="mr-1">mdi-magnify</v-icon>
					検索
				</v-btn>
			</template>

			<v-card :tile="$vuetify.breakpoint.xs">
				<v-app-bar dense dark flat color="primary">
					<v-app-bar-title class="color-white">検索</v-app-bar-title>
					<v-spacer />
					<v-btn icon dark @click="dialog = false" color="white">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-app-bar>

				<v-form class="pa-2" ref="form">
					<h6 class="text-body-2 font-weight-bold mt-2">表示する配車依頼書の状況</h6>
					<v-row no-gutters class="mt-2">
						<v-checkbox
							multiple
							class="mr-2"
							v-model="q.status_type_in"
							label="発注済"
							value="sent"
						/>
						<v-checkbox
							multiple
							class="mr-2"
							v-model="q.status_type_in"
							label="下書き"
							value="draft"
						/>
						<v-checkbox
							multiple
							class="mr-2"
							v-model="q.status_type_in"
							label="確認待ち"
							value="pending"
						/>
						<v-checkbox
							multiple
							class="mr-2"
							v-model="q.status_type_in"
							label="却下"
							value="rejected"
						/>
					</v-row>

					<v-select
						v-model="q.supplier_id_eq"
						label="運送会社"
						:items="suppliers"
						item-value="id"
						item-text="name"
						class="mt-4"
						outlined
						dense
					/>
					<v-menu
						ref="orderDateRangeMenu"
						v-model="orderDateRangeMenu"
						:close-on-content-click="false"
						:return-value.sync="orderDateRange"
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="orderDatesText"
								label="注文日"
								class="mt-4"
								clearable
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker
							class="date-picker"
							v-model="orderDateRange"
							no-title
							scrollable
							range
							locale="ja-JP"
						>
							<v-spacer />
							<v-btn text color="grey" @click="orderDateRangeMenu = false"> キャンセル </v-btn>
							<v-btn text color="primary" @click="changeDateRange('orderDateRange', 'order_date')">
								決定
							</v-btn>
						</v-date-picker>
					</v-menu>
				</v-form>

				<v-card-actions>
					<v-row no-gutters>
						<v-col cols="0" sm="2"></v-col>
						<v-col cols="12" sm="8">
							<v-row class="ma-0 pa-0" justify="center">
								<v-btn class="ma-1" @click="searchDeliveryOrders" color="secondary">
									<v-icon class="mr-2">mdi-magnify</v-icon>
									検索</v-btn
								>
								<v-btn class="ma-1" @click="resetForm" outlined color="secondary">
									<v-icon class="mr-2">mdi-autorenew</v-icon>
									クリア</v-btn
								>
							</v-row>
						</v-col>
						<v-col cols="0" sm="2">
							<v-row v-if="!$vuetify.breakpoint.xs" no-gutters justify="end">
								<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
							</v-row>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import common from "../../../helper/common"

export default {
	props: {
		suppliers: {
			type: Array,
			required: true,
		},
		text: {
			type: Boolean,
			default: false,
		},
		query: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			orderDateRange: [],
			orderDateRangeMenu: false,
			dialog: false,
			q: {
				supplier_id_eq: null,
				order_date_lteq: null,
				order_date_gteq: null,
				status_type_in: [],
			},
		}
	},
	mounted(){
		this.q = this.query
	},
	methods: {
		searchDeliveryOrders() {
			this.$emit("search-delivery-orders", this.q)
			this.dialog = false
		},
		resetForm() {
			this.$refs.form.reset()
		},
		changeDateRange(dateRange, queryName) {
			if (this[dateRange].length) {
				const firstDate = this[dateRange][0]
				const lastDate = this[dateRange][this[dateRange].length - 1]
				if (firstDate > lastDate) {
					this.q[`${queryName}_gteq`] = lastDate
					this.q[`${queryName}_lteq`] = firstDate
				} else {
					this.q[`${queryName}_gteq`] = firstDate
					this.q[`${queryName}_lteq`] = lastDate
				}
			} else {
				this.q[`${queryName}_gteq`] = null
				this.q[`${queryName}_lteq`] = null
			}
			this.$refs[`${dateRange}Menu`].save(this[dateRange])
		},
	},
	computed: {
		orderDatesText: {
			get() {
				return this.orderDateRange.length
					? this.orderDateRange.map((d) => common.formatDate(d)).join(" ~ ")
					: null
			},
			set(newVal) {
				this.orderDateRange = []
				this.changeDateRange("orderDateRange", "order_date")
				return
			},
		},
	},
	watch: {
		query: {
			handler(val) {
				this.q = val
				console.log(val)
			},
			deep: true,
		},
	},
}
</script>